<template>
	<div class="input-button-go">

		<div class="input-content">

			<div
				v-if="error !== ''"
				class="absolute pin-l pin-b text-xxs p-px">
				{{ error }}
			</div>

		</div>

		<div class="action-content">
			<div class="action-button" @click="go()">
				<fa icon="link"></fa>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'InputButtonGo',
		props: {
			value: [String, Array, Number],
			id: [Number, String],
			input: Object,
			label: String,
			type: {
				type: [String, Number],
				default: 'text'
			},
			placeholder: String,
			readonly: {
				type: Boolean,
				default: false
			},
			siblings: {
				type: Array,
				default: () => []
			},
			saveFunction: {
				type: [Function, String],
				default: ''
			},
			separador: String,
			saveObject: {
				type: [Function, String],
				default: ''
			},
			normal: {
				type: Boolean,
				default: false
			},
			format: Function,
			onlyConfirm: {
				type: Boolean,
				default: false
			},
			border: {
				type: String,
				default: ''
			},
			rows: {
				type: Number,
				default: 1
			},
			required: {
				type: Boolean,
				default: false
			},
			textPre: String,
			textPos: String
		},
		data () {
			return {
				saving: false,
				error: ''
			}
		},
		methods: {
			go() {
				if(!this.input.value) return
				this.openwindow(`/ficha/${this.input.entidad}/${this.input.value}`,'_blank')
			}
		}
	}
</script>

<style lang="scss">
.input-button-go {
	height: -webkit-fill-available;
	width: 100%!important;
	display: flex;
	flex-grow: 1;
	align-items:center;
	position: relative;
	border-radius: 3px;
	border: 0px;
	.input-content {
		visibility: hidden;
		display: flex;
		align-items: center;
		flex-grow: 1;
		width: 100%;
	}
	.action-content {
		display: flex;
    	flex-shrink: 0;
		.action-button {
			padding: 0px;
			margin-left: 2px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #ffffff;
			color: #4a596a;
			border: 1px solid #e4e7ed;
			padding: 0px;
			margin-left: 2px;
			border-radius: 3px;
			height: 28px;
			width: 28px;
			min-width: 28px;
			font-size: 13px;
			cursor: pointer;
		}
	}
}
</style>
